"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoExpiresHalfway = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RoExpiresHalfway = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    expiration_date: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    rental_extension_fee: typebox_1.Type.String(),
});
//# sourceMappingURL=ro-expires-halfway.js.map